import { render } from "./JapchaeTteokbokkiView.vue?vue&type=template&id=704f1611"
import script from "./JapchaeTteokbokkiView.vue?vue&type=script&lang=js"
export * from "./JapchaeTteokbokkiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__